
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-7f05f56e&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Customer.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Customer.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-7f05f56e!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Customer.vue"),
  /* scopeId */
  "data-v-7f05f56e",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/Customer/Customer.vue
// module id = 668
// module chunks = 0